import { render, staticRenderFns } from "./advertisement.vue?vue&type=template&id=71feb968&scoped=true"
import script from "./advertisement.vue?vue&type=script&lang=js"
export * from "./advertisement.vue?vue&type=script&lang=js"
import style0 from "./advertisement.vue?vue&type=style&index=0&id=71feb968&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71feb968",
  null
  
)

export default component.exports